export enum ExpirationDateType {
    Hour24 = 'hour24',
    Hour48 = 'hour48',
    Week1 = 'week1',
    Month1 = 'month1'
}
